import useSWR, { useSWRConfig } from 'swr';

const useRegisterConfirmPassword = (userId, code, dataClient, swrOptions = {}) => {
    const url = `/identity/account/register/confirmEmail?userId=${userId}&code=${code}`;
    const swrConfig = useSWRConfig();

    dataClient.swrConfig = swrConfig;

    if (swrOptions.refreshInterval > 0) {
        dataClient.cacheExirationMs = swrOptions.refreshInterval;
    }

    const { data, error, isValidating, mutate } = useSWR(url, dataClient.fetcher);

    const result = {
        result: data ? data : null,
        isLoading: !error && !data,
        isError: !(!error),
        error: error,
        isValidating: isValidating,
        refetchResult: mutate,
    }

    return result;
}

export {
    useRegisterConfirmPassword
}